import PictureUpload, { SelectedImageData, Props } from './PictureUpload.container';

export type { SelectedImageData, Props };

export default PictureUpload;
